<template>
  <div>
    <AppHeader />
 
  <div>
    <div class="left">
      <div class="row" style="padding-left: 15px">
        <!-- <div class="col-sm-1">
          <div
            class="dropdown"
            style="
              position: fixed;
              left: 0;
              top: 0;
              padding: 0;
              margin-top: 0;
              margin-bottom: 0;
            "
          >
          
          </div>
        </div> -->
        <div v-if="!loading" class="col-sm-12">
          <div style="color: #fff" class="header-section">
            <h1>{{ listNameDisplay }}</h1>
            <!-- <button class="btn btn-primary text-white leftBut" @click="navigateBack">
        {{ adminLabels("backBut") }}
      </button> -->
          </div>

          <!-- Filter Section -->
          <div
            id="filterbox"
            style="
              display: flex;
              align-items: end;
              justify-content: space-between;
              content-visibility: hidden;
            "
            class="filter_wrapper"
          >
            <div
              v-for="column in filterColumns"
              :key="column.fieldname"
              class="filterbox"
            >
              <div
                v-if="column.typeoffilter == '2D'"
                className="flex-between-a-center"
              >
                <div style="margin: 0 1rem">
                  <label>{{ column.title }} Start</label>
                  <input
                    type="date"
                    :id="'col-' + column.fieldname"
                    :data-filter-name="column.fieldname"
                    class="filter-inp form-control"
                    @keyup.enter="setFilter"
                  />
                </div>
                <div style="margin: 0 1rem">
                  <label>{{ column.title }} End</label>
                  <input
                    type="date"
                    :id="'col-' + column.fieldname"
                    :data-filter-name="column.fieldname"
                    class="filter-inp form-control"
                    @keyup.enter="setFilter"
                  />
                </div>
              </div>
              <div v-if="column.typeoffilter == '2D'" class="flex-between-a-center">
                <div style="margin: 0 1rem; width: 100%">
                  <label>{{ column.title }} Range</label>
                  <VueDatePicker
                    range
                    v-model="dateRange"
                    format="MM/dd/yyyy"
                    class="filter-inp"
                    @update:modelValue="handleDateChange($event, column.fieldname)"
                    :enable-time-picker="false" 
                    @closed="setFilter2d(column.fieldname)"
                  />
                </div>
              </div>
              <div v-else>
                <label>{{ column.title }}</label>
                <input
                  :type="column.typeoffilter == 'D' ? 'date' : 'text'"
                  :id="'col-' + column.fieldname"
                  class="filter-inp form-control"
                  @keyup.enter="loadData"
                  @input="setFilter($event, column.fieldname)"
                />
              </div>
            </div>
            <button
              class="btn btn-success search-btn"
              @click="searchGlobalFilter"
            >
              Search
            </button>
            <button
              class="btn btn-primary clear-btn text-white"
              @click="clearFilters"
            >
              Clear
            </button>
          </div>

          <!-- Buttons Section -->
          <div
            id="buttons-box"
            style="
              margin-top: 1rem;
              display: flex;
              justify-content: end;
              align-items: center;
            "
            class="buttons_wrapper"
          >
            <button
              v-for="button in buttons"
              :key="button.actioncode"
              class="btn btn-success action-btn"
              style="margin: 0 0.4rem"
              :data-action="button.actioncode"
              @click="handleButtonAction(button.actioncode)"
            >
              {{ button.name }}
            </button>
          </div>

          <!-- Table Section -->
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr style="color: white">
                  <th v-for="column in displayColumns" :key="column.fieldname">
                    <span
                      style="cursor: pointer"
                      @click="sortColumn(column.fieldname)"
                    >
                      {{ column.title }}
                    </span>
                    <span
                      @click="clearSort"
                      style="cursor: pointer"
                      v-if="sort.fieldname === column.fieldname"
                    >
                      <span v-if="sort.by === 'ASC'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          style="fill: #fff"
                        >
                          <path
                            d="M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM7 3.99H5v12H2l4 4 4-4H7zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                          ></path>
                        </svg>
                      </span>
                      <span v-if="sort.by === 'DESC'">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          style="fill: #fff"
                        >
                          <path
                            d="M19.707 14.707A1 1 0 0 0 19 13h-7v2h4.586l-4.293 4.293A1 1 0 0 0 13 21h7v-2h-4.586l4.293-4.293zM6 3.99l-4 4h3v12h2v-12h3zM17 3h-2c-.417 0-.79.259-.937.649l-2.75 7.333h2.137L14.193 9h3.613l.743 1.981h2.137l-2.75-7.333A1 1 0 0 0 17 3zm-2.057 4 .75-2h.613l.75 2h-2.113z"
                          ></path>
                        </svg>
                      </span>
                    </span>
                  </th>
                </tr>
              </thead>
            <tbody>
              <tr v-if="data.length === 0">
                <td :colspan="displayColumns.length" style="text-align: center; color: white;">
                  No data available
                </td>
              </tr>
              <tr v-else v-for="(row, index) in data" :key="index">
                <td>{{ row.price }}</td>
                <td>{{ row.isHotKey }}</td>
                <td>{{ row.created_at }}</td>
              </tr>
            </tbody>
            </table>
          </div>

          <!-- Pagination -->

          <ul class="pagination">
            <li class="page-item" :class="{ disabled: currentPage === 1 }">
              <a v-if="currentPage === 1" class="page-link" href="#"
                >Previous</a
              >
              <a v-else class="page-link" href="#" @click="changePage(currentPage - 1)"
                >Previous</a
              >
            </li>

            <li v-if="currentPage > 3">
              <a class="page-link" href="#" @click="changePage(1)">1</a>
            </li>

            <li v-if="currentPage > 4">
              <span class="page-link">...</span>
            </li>

            <li
              v-for="pageNumber in visiblePages"
              :key="pageNumber"
              :class="{ active: currentPage === pageNumber }"
            >
              <a class="page-link" href="#" @click="changePage(pageNumber)">{{
                pageNumber
              }}</a>
            </li>

            <li v-if="currentPage < totalPages - 3">
              <span class="page-link">...</span>
            </li>

            <li v-if="currentPage < totalPages - 2">
              <a class="page-link" href="#" @click="changePage(totalPages)">{{
                totalPages
              }}</a>
            </li>

            <li
              class="page-item"
              :class="{ disabled: currentPage === totalPages }"
            >
            <a v-if="currentPage === totalPages" class="page-link" href="#"
                >Next</a
                          >
                        <a v-else class="page-link" href="#" @click="changePage(currentPage + 1)">
              Next
            </a>
            </li>
          </ul>
          <!-- <div id="pagination-div">
            <button
              v-for="page in totalPages"
              :key="page"
              @click="changePage(page)"
              :class="{ active: page === currentPage }"
            >
              {{ page }}
            </button>
          </div> -->
        </div>
        <!-- <div
          v-else
          class="col-sm-11"
          style="
            color: white;
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          Loading....
        </div> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import commonServices from "@/shared/commonServices";
// import ReportsMenu from "@/components/ReportsMenu";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import axios from "axios";
import * as XLSX from "xlsx";
import * as Swal from 'sweetalert2';
export default {
  // mixins: [commonServices],
  components: {  VueDatePicker },
  data() {
    return {
      listname: "",
      listNameDisplay: "",
      data: [],
      loading: true,
      columns: [],
      dateRange: [],
      buttons: [],
      sort: { fieldname: null, by: "ASC" },
      filters: [],
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: 20,
    };
  },
  computed: {
    visiblePages() {
      let startPage = Math.max(1, this.currentPage - 2);
      let endPage = Math.min(this.totalPages, startPage + 4);

      if (endPage - startPage < 4) {
        startPage = Math.max(1, endPage - 4);
      }

      return Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
      );
    },
   displayColumns() {
  const debugColumns = [
    { fieldname: 'price', title: 'Price', display: 1 },
    { fieldname: 'isHotKey', title: 'Hot Key', display: 1 },
    { fieldname: 'created_at', title: 'Date', display: 1 }
  ];
  return debugColumns;
},
    filterColumns() {
      return this.columns.filter((col) => col.filter === 1);
    },
  },
  async mounted() {
    this.listname = this.$route.params.listname; 
    console.log(this.listname);
    console.log("asd");
    // this.listname = this.$route.query.listname;
    await this.getInit();
  },
  methods: {
    async getInit() {
      await this.loadData();
      this.columns = await this.getColumns();
      this.columns = this.columns || []; 
      this.buttons = await this.getButtons();
    },
    async loadData() {
      Swal.showLoading();
      this.data = await this.getData();
      this.loading = false;
      Swal.close();
    },
  async getColumns() {
  try {
    const token = localStorage.getItem('authToken');
    const response = await axios.post(
      `${this.$BASE_API_URL}/api/reports/filter`,
      { listname: this.listname, listtype: "column" },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    console.log("Columns API Response:", response.data);
    this.listNameDisplay = response.data.listname || "";
    return response.data?.columns || []; // Use optional chaining
  } catch (error) {
    console.error("Error fetching columns:", error);
    return [];
  }
},
async getData(count = 0) {
  const token = localStorage.getItem('authToken');
  const obj = {
    listname: this.listname,
    listtype: "data",
    filter: this.filters,
    pageNumber: this.currentPage,
    listcount: count != 0 ? count : this.itemsPerPage,
  };

  if (this.sort.fieldname != null) {
    obj["sort"] = this.sort;
  }

  try {
    const response = await axios.post(
      `${this.$BASE_API_URL}/api/reports/filter`,
      obj, 
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    console.log("Full API response:", response.data); // Debug full response
    console.log("Results data:", response.data.data.results); // Debug actual data
    
    this.totalPages = Math.ceil(response.data.data.totalrows / this.itemsPerPage);
    return response.data.data.results || [];
    
  } catch (error) {
    console.error('Error fetching data:', error);
    this.$toast.error(error.response?.data?.message || 'Failed to fetch data');
    return [];
  }
},
async getButtons() {
  const token = localStorage.getItem('authToken');
  
  try {
    const response = await axios.post(
      `${this.$BASE_API_URL}/api/reports/filter`,
      { 
        listname: this.listname,
        listtype: "buttons"
      },
      {  
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    
    return response.data.buttons || [];
    
  } catch (error) {
    console.error('Error fetching buttons:', error);
    this.$toast.error(error.response?.data?.message || 'Failed to fetch buttons');
    return []; // Return empty array on error
  }
},
    changePage(page) {
      this.currentPage = page;
      this.loadData();
    },
    setFilter(event, fieldname) {
      const i = this.filters.findIndex((el) => el.fieldname == fieldname);
      if (i < 0) {
        this.filters.push({
          fieldname,
          value: `%${event.target.value}%`,
        });
      } else {
        this.filters[i] = {
          fieldname,
          value: `%${event.target.value}%`,
        };
      }
    },
    formatDate(date) {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
      const dd = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
      return `${yyyy}-${mm}-${dd}`;
    },
    handleDateChange(value, fieldname) {
      if (!value || value.length === 0) {
        console.log("Date range cleared");
        this.dateRange = []; // Reset value
        const i = this.filters.findIndex((el) => el.fieldname == fieldname);
        if (i > -1) {
          this.filters.splice(i, 1);
        }
        this.loadData();
      }
    },
    setFilter2d(fieldname) {
      if(this.dateRange.length != 2){
        return;
      } 
      const i = this.filters.findIndex((el) => el.fieldname == fieldname);
      if (i < 0) {
        this.filters.push({
          fieldname,
          value: `${this.formatDate(this.dateRange[0])}`,
          value2: `${this.formatDate(this.dateRange[1])}`,
        });
      } else {
        this.filters[i] = {
          fieldname,
          value: `${this.formatDate(this.dateRange[0])}`,
          value2: `${this.formatDate(this.dateRange[1])}`,
        };
      }
      this.loadData();
    },
    
    searchGlobalFilter() {
      this.loadData();
    },
    clearSort() {
      this.sort = { fieldname: null, by: "ASC" };
      this.loadData();
    },
    clearFilters() {
      this.filters = [];
      this.dateRange = [];
      document.querySelectorAll('.filter-inp').forEach(el => {
        el.value = '';
      })
      this.loadData();
    },
    sortColumn(field) {
      this.sort = {
        fieldname: field,
        by: this.sort.by === "ASC" ? "DESC" : "ASC",
      };
      this.loadData();
    },
    async handleButtonAction(action) {
      if (action === "ExportExcel") {
        const data = await this.getData(99999999999);
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        XLSX.writeFile(workbook, `${this.listNameDisplay}.xlsx`);
      }
      if (action === "PrintPdf") {
        this.printReport();
      }
    },
    async printReport() {
      const data = await this.getData(99999999999);
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = (nowDate.getMonth() + 1).toString().padStart(2, "0");
      let day = nowDate.getDate().toString().padStart(2, "0");
      let hours = nowDate.getHours().toString().padStart(2, "0");
      let minutes = nowDate.getMinutes().toString().padStart(2, "0");
      let seconds = nowDate.getSeconds().toString().padStart(2, "0");

      let reportHeader = `<h2>Report: ${this.listNameDisplay}</h2>`;
      let reportFooter = `<p>Printed on: ${year}-${month}-${day} ${hours}:${minutes}:${seconds}</p>`;

      // Create table headers
      let tableHeaders = this.displayColumns
        .map((column) => `<th>${column.title}</th>`)
        .join("");

      // Create table rows
      let tableRows = data
        .map((row, index) => {
          let rowData = this.displayColumns
            .map((column) => `<td>${row[column.fieldname]}</td>`)
            .join("");
          return `<tr class="${
            index % 2 === 0 ? "even" : "odd"
          }">${rowData}</tr>`;
        })
        .join("");

      let table = `
    <table>
      <thead><tr>${tableHeaders}</tr></thead>
      <tbody>${tableRows}</tbody>
    </table>
  `;

      const viaInvStr = ` <html>
    <head>
      <title>Print Report</title>
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid black; padding: 8px; text-align: left; }
        th { background-color: #f2f2f2; }
        .even { background-color: #f9f9f9; }
        .odd { background-color: #ffffff; }
      </style>
    </head>
    <body>
      ${reportHeader}
      ${table}
      ${reportFooter}
    </body>
    </html>
  `;
      this.sharedPrintElemmRep(viaInvStr);
    },
  },
};
</script>

<style scoped>
label {
  color: #fff;
}
.table-striped tbody tr:nth-child(even) td {
  color: #fff;
}
#pagination-div {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
#pagination-div button {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 5px;
  cursor: pointer;
  border-radius: 5px;
}
#pagination-div button.active {
  background: #0056b3;
  font-weight: bold;
}
#pagination-div button:hover {
  background: #0056b3;
}
.flex-between-a-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
